import { get, ref, set } from 'firebase/database';
import { database } from '../firebase.js';

/**
 * Check if this IP has visited before.
 * Returns true if this is their FIRST visit, false if they've been here before.
 */
export async function checkFirstVisit() {
    try {
        // 1. Get public IP
        const res = await fetch('https://api.ipify.org?format=json');
        const data = await res.json();
        const ip = String(data.ip || '').trim();
        if (!ip) return false; // can't determine IP — skip welcome

        // 2. Sanitize for Firebase key (dots/colons not allowed)
        const key = ip.replace(/[.:]/g, '_');

        // 3. Check Firebase
        const snap = await get(ref(database, `sigmund_visitors/${key}`));
        if (snap.exists()) {
            return false; // returning visitor
        }

        // 4. First visit — save and return true
        await set(ref(database, `sigmund_visitors/${key}`), {
            ip,
            firstVisit: new Date().toISOString()
        });
        return true;
    } catch (err) {
        console.warn('[firstVisitCheck] Error:', err);
        return false; // on error, skip welcome
    }
}
